import { SVGMotionProps, m as motion } from 'framer-motion'
import { media } from '@app/common/src/theme'
import { theme } from '@dtx-company/shared-components/src'
import styled from 'styled-components'

const Path = (props: SVGMotionProps<SVGPathElement>): JSX.Element => (
  <motion.path fill="transparent" strokeWidth="3" stroke="white" strokeLinecap="round" {...props} />
)

const StyledMotionButton = styled(motion.button)`
  ${media.custom(1087)} {
    display: none;
  }
  background-color: transparent;
  border: none;
  padding: 2px;
  cursor: pointer;

  :active,
  :focus,
  svg:active,
  svg:focus {
    outline: none;
  }
`

export const MenuToggle = ({
  toggle,
  isOpen,
  color = theme.colors.primary.white
}: {
  isOpen: boolean
  toggle: () => void
  color?: string
}): JSX.Element => (
  <StyledMotionButton
    initial={false}
    animate={isOpen ? 'open' : 'closed'}
    onClick={toggle}
    aria-label={isOpen ? 'Close Menu' : 'Open Menu'}
    aria-expanded={isOpen}
  >
    <svg width="22" height="22" viewBox="0 0 22 22">
      <Path
        variants={{
          closed: { d: 'M 2 4.5 L 20 4.5' },
          open: { d: 'M 3 18.5 L 17 4.5' }
        }}
        stroke={color}
      />
      <Path
        d="M 2 11.423 L 20 11.423"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 }
        }}
        transition={{ duration: 0.1 }}
        stroke={color}
      />
      <Path
        variants={{
          closed: { d: 'M 2 18.346 L 20 18.346' },
          open: { d: 'M 3 4.5 L 17 18.346' }
        }}
        stroke={color}
      />
    </svg>
  </StyledMotionButton>
)
